<div>
  <div class="grid grid-cols-12  items-center justify-center bg-[#fff]">
    <div class="col-span-1 flex justify-center">
      <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollDiv(-1)">
        <mat-icon svgIcon="arrow-left"></mat-icon>
      </button>
    </div>
    <div class="col-span-10">
      <div class="flex justify-center">
        <div class="horizontal-snap" id="preview">
          <!----->
          <div class="flex justify-center items-center shadow p-2 mx-2 cursor-pointer" onclick="location.href='service-categories';" style="cursor: pointer;" *ngFor="let sector of sectors">
            <div class="grid grid-rows-2">
              <div class="flex justify-center items-center">
                <mat-icon [svgIcon]="sector.icon"></mat-icon>
              </div>
              <div class="text-white flex justify-center items-center">{{ sector.title }}</div>
            </div>
          </div>
          <!----->
        </div>
      </div>
    </div>
    <div class="col-span-1 flex justify-center">
      <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollDiv(1)">
        <mat-icon svgIcon="arrow-right"></mat-icon>
      </button>
    </div>
  </div>
  <!--- BEGIN: Carousel ---->
  <div class="col-12 h-3/6">
    <ngb-carousel [interval]="10000" [pauseOnHover]="true" [showNavigationArrows]="true">
      <ng-template *ngFor="let imageSrc of images" ngbSlide>
        <img [src]="imageSrc" class="h-[60vh] w-full object-cover"/>
      </ng-template>
    </ngb-carousel>
  </div>
  <!-- END: Carousel -->

  <!-- BEGIN: SEARCH FIELD -->
  <div class="flex justify-center relative -mt-7">
    <div class="bg-[#fff] px-4 py-3 rounded-3xl w-2/5 border border-gray-300">
      <div class="flex items-center">
        <input placeholder="Search Services" class="text-xl" style="outline: none; width: 90%;" />
        <mat-icon svgIcon="search" class="ml-2" style="width: 20px !important; height: 20px !important; color: #28409A;"></mat-icon>
      </div>
    </div>
  </div>
  <!-- END: SEARCH FIELD -->

  <!-- BEGIN: Most Searched services --->
  <div class="bg-gray-100 py-5">
      <div class="flex justify-center my-3">
        <span class="font-bold text-2xl text-[#28409A]">
          Most searched services
        </span>
      </div>
      <!-- BEGIN: Most searched Services -->
      <div class="container-fluid">
        <div class="row">
          <div class="flex justify-center items-center">
            <div class="px-3 py-2 rounded-2xl border border-gray-300 mx-2" *ngFor="let service of mostSearched">
              {{ service.name }}
            </div>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
      <!-- END: Most searched Services -->
  </div>
  <!-- END: Most Searched services --->
  <svg id="wave1" style="transform:rotate(0deg); transition: 0.3s" viewBox="0 0 1440 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path style="transform:translate(0, 0px); opacity:1" fill="#dcdcdc" d="M0,60L48,50C96,40,192,20,288,25C384,30,480,60,576,73.3C672,87,768,83,864,83.3C960,83,1056,87,1152,81.7C1248,77,1344,63,1440,61.7C1536,60,1632,70,1728,68.3C1824,67,1920,53,2016,50C2112,47,2208,53,2304,58.3C2400,63,2496,67,2592,61.7C2688,57,2784,43,2880,38.3C2976,33,3072,37,3168,38.3C3264,40,3360,40,3456,40C3552,40,3648,40,3744,46.7C3840,53,3936,67,4032,61.7C4128,57,4224,33,4320,25C4416,17,4512,23,4608,26.7C4704,30,4800,30,4896,36.7C4992,43,5088,57,5184,61.7C5280,67,5376,63,5472,63.3C5568,63,5664,67,5760,71.7C5856,77,5952,83,6048,73.3C6144,63,6240,37,6336,30C6432,23,6528,37,6624,35C6720,33,6816,17,6864,8.3L6912,0L6912,100L6864,100C6816,100,6720,100,6624,100C6528,100,6432,100,6336,100C6240,100,6144,100,6048,100C5952,100,5856,100,5760,100C5664,100,5568,100,5472,100C5376,100,5280,100,5184,100C5088,100,4992,100,4896,100C4800,100,4704,100,4608,100C4512,100,4416,100,4320,100C4224,100,4128,100,4032,100C3936,100,3840,100,3744,100C3648,100,3552,100,3456,100C3360,100,3264,100,3168,100C3072,100,2976,100,2880,100C2784,100,2688,100,2592,100C2496,100,2400,100,2304,100C2208,100,2112,100,2016,100C1920,100,1824,100,1728,100C1632,100,1536,100,1440,100C1344,100,1248,100,1152,100C1056,100,960,100,864,100C768,100,672,100,576,100C480,100,384,100,288,100C192,100,96,100,48,100L0,100Z"></path>
    <path style="transform:translate(0, 50px); opacity:0.9"  fill="#cdcdcd" d="M0,0L48,0C96,0,192,0,288,10C384,20,480,40,576,48.3C672,57,768,53,864,43.3C960,33,1056,17,1152,18.3C1248,20,1344,40,1440,53.3C1536,67,1632,73,1728,70C1824,67,1920,53,2016,48.3C2112,43,2208,47,2304,40C2400,33,2496,17,2592,16.7C2688,17,2784,33,2880,45C2976,57,3072,63,3168,66.7C3264,70,3360,70,3456,65C3552,60,3648,50,3744,43.3C3840,37,3936,33,4032,26.7C4128,20,4224,10,4320,6.7C4416,3,4512,7,4608,8.3C4704,10,4800,10,4896,11.7C4992,13,5088,17,5184,16.7C5280,17,5376,13,5472,21.7C5568,30,5664,50,5760,53.3C5856,57,5952,43,6048,31.7C6144,20,6240,10,6336,6.7C6432,3,6528,7,6624,20C6720,33,6816,57,6864,68.3L6912,80L6912,100L6864,100C6816,100,6720,100,6624,100C6528,100,6432,100,6336,100C6240,100,6144,100,6048,100C5952,100,5856,100,5760,100C5664,100,5568,100,5472,100C5376,100,5280,100,5184,100C5088,100,4992,100,4896,100C4800,100,4704,100,4608,100C4512,100,4416,100,4320,100C4224,100,4128,100,4032,100C3936,100,3840,100,3744,100C3648,100,3552,100,3456,100C3360,100,3264,100,3168,100C3072,100,2976,100,2880,100C2784,100,2688,100,2592,100C2496,100,2400,100,2304,100C2208,100,2112,100,2016,100C1920,100,1824,100,1728,100C1632,100,1536,100,1440,100C1344,100,1248,100,1152,100C1056,100,960,100,864,100C768,100,672,100,576,100C480,100,384,100,288,100C192,100,96,100,48,100L0,100Z"></path>
  </svg>
  <div class="my-5">
    <!-- BEGIN: SERVICE CATEGORIES -->
    <div class="mx-5">
      <span class="text-2xl font-bold text-[#28409A]">Service Categories</span>
    </div>
    <div class="grid grid-cols-12  items-center justify-center py-5">
      <div class="col-span-1 flex justify-center">
        <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollServices(-1)">
          <mat-icon svgIcon="arrow-left"></mat-icon>
        </button>
      </div>
      <div class="col-span-10">
        <div class="flex justify-center items-center">
          <div class="service-categories" id="serviceId">
            <!----->
            <div class="" *ngFor="let service of services">
              <span class="my-2 border cursor-pointer shadow-sm border-gray-300 rounded-3xl px-4 py-2 flex justify-center items-center w-40 h-16" [style.backgroundColor]="service.color"  routerLink="/service-categories">
                  {{ service.title }}
              </span>
            </div>
            <!----->
          </div>
        </div>
      </div>
      <div class="col-span-1 flex justify-center">
        <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollServices(1)">
          <mat-icon svgIcon="arrow-right"></mat-icon>
        </button>
      </div>
    </div>
    <!-- BEGIN: SERVICE CATEGORIES -->
  </div>
  <div class="bg-gray-200 py-5">
    <!-- BEGIN: SERVICE PROVIDERS -->
    <div class="mx-5 py-3">
      <span class="text-2xl font-bold text-[#28409A]">Service Providers</span>
    </div>
    <div class="grid grid-cols-12  items-center justify-center mt-3 pb-5">
      <div class="col-span-1 flex justify-center">
        <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollProviders(-1)">
          <mat-icon svgIcon="arrow-left"></mat-icon>
        </button>
      </div>
      <div class="col-span-10">
        <div class="flex justify-center">
          <div class="service-providers" id="providers">
            <!----->
            <div class="flex justify-center items-center shadow-sm py-2 px-4 mx-2" *ngFor="let provider of serviceProviders">
              <div class="grid grid-rows-2">
                <div class="flex justify-center items-center">
                  <img [src]="provider.image" width="30" height="30">
                </div>
                <div class="text-[#28409A] flex justify-center items-center">{{ provider.title }}</div>
              </div>
            </div>
            <!----->
          </div>

        </div>
      </div>
      <div class="col-span-1 flex justify-center">
        <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollProviders(1)">
          <mat-icon svgIcon="arrow-right"></mat-icon>
        </button>
      </div>
    </div>
    <!-- END: SERVICE PROVIDERS -->
  </div>


    <!-- BEGIN: POPULAR SERVICES -->
    <div class="">
      <div class="mx-5 my-5">
        <span class="text-2xl font-bold text-[#28409A]">Popular Services</span>
      </div>
      <div class="grid grid-cols-12  items-center justify-center mt-3 mb-5">
        <div class="col-span-1 flex justify-center">
          <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollPopularServices(-1)">
            <mat-icon svgIcon="arrow-left"></mat-icon>
          </button>
        </div>
        <div class="col-span-10">
          <div class="flex justify-center items-center">
            <div class="service-categories" id="serviceId">
              <!----->
              <div class="flex items-center" *ngFor="let service of services">
                <span class="my-2 border cursor-pointer shadow-sm border-gray-300 rounded-3xl px-4 py-2 flex justify-center items-center w-40 h-16" [style.backgroundColor]="service.color"  routerLink="/service-categories">
                    {{ service.title }}
                </span>
              </div>
              <!----->
            </div>
          </div>
        </div>
        <div class="col-span-1 flex justify-center">
          <button class="flex justify-center items-center p-2  border border-blue-500  text-black rounded-full" (click)="scrollPopularServices(1)">
            <mat-icon svgIcon="arrow-right"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <svg id="wave" style="transform:rotate(0deg); transition: 0.3s" viewBox="0 0 1440 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <path style="transform:translate(0, 0px); opacity:1" fill="#28409A" d="M0,60L48,50C96,40,192,20,288,25C384,30,480,60,576,73.3C672,87,768,83,864,83.3C960,83,1056,87,1152,81.7C1248,77,1344,63,1440,61.7C1536,60,1632,70,1728,68.3C1824,67,1920,53,2016,50C2112,47,2208,53,2304,58.3C2400,63,2496,67,2592,61.7C2688,57,2784,43,2880,38.3C2976,33,3072,37,3168,38.3C3264,40,3360,40,3456,40C3552,40,3648,40,3744,46.7C3840,53,3936,67,4032,61.7C4128,57,4224,33,4320,25C4416,17,4512,23,4608,26.7C4704,30,4800,30,4896,36.7C4992,43,5088,57,5184,61.7C5280,67,5376,63,5472,63.3C5568,63,5664,67,5760,71.7C5856,77,5952,83,6048,73.3C6144,63,6240,37,6336,30C6432,23,6528,37,6624,35C6720,33,6816,17,6864,8.3L6912,0L6912,100L6864,100C6816,100,6720,100,6624,100C6528,100,6432,100,6336,100C6240,100,6144,100,6048,100C5952,100,5856,100,5760,100C5664,100,5568,100,5472,100C5376,100,5280,100,5184,100C5088,100,4992,100,4896,100C4800,100,4704,100,4608,100C4512,100,4416,100,4320,100C4224,100,4128,100,4032,100C3936,100,3840,100,3744,100C3648,100,3552,100,3456,100C3360,100,3264,100,3168,100C3072,100,2976,100,2880,100C2784,100,2688,100,2592,100C2496,100,2400,100,2304,100C2208,100,2112,100,2016,100C1920,100,1824,100,1728,100C1632,100,1536,100,1440,100C1344,100,1248,100,1152,100C1056,100,960,100,864,100C768,100,672,100,576,100C480,100,384,100,288,100C192,100,96,100,48,100L0,100Z"></path>
      <path style="transform:translate(0, 50px); opacity:0.9" class="nationalFlag" fill="#fcd20f" d="M0,0L48,0C96,0,192,0,288,10C384,20,480,40,576,48.3C672,57,768,53,864,43.3C960,33,1056,17,1152,18.3C1248,20,1344,40,1440,53.3C1536,67,1632,73,1728,70C1824,67,1920,53,2016,48.3C2112,43,2208,47,2304,40C2400,33,2496,17,2592,16.7C2688,17,2784,33,2880,45C2976,57,3072,63,3168,66.7C3264,70,3360,70,3456,65C3552,60,3648,50,3744,43.3C3840,37,3936,33,4032,26.7C4128,20,4224,10,4320,6.7C4416,3,4512,7,4608,8.3C4704,10,4800,10,4896,11.7C4992,13,5088,17,5184,16.7C5280,17,5376,13,5472,21.7C5568,30,5664,50,5760,53.3C5856,57,5952,43,6048,31.7C6144,20,6240,10,6336,6.7C6432,3,6528,7,6624,20C6720,33,6816,57,6864,68.3L6912,80L6912,100L6864,100C6816,100,6720,100,6624,100C6528,100,6432,100,6336,100C6240,100,6144,100,6048,100C5952,100,5856,100,5760,100C5664,100,5568,100,5472,100C5376,100,5280,100,5184,100C5088,100,4992,100,4896,100C4800,100,4704,100,4608,100C4512,100,4416,100,4320,100C4224,100,4128,100,4032,100C3936,100,3840,100,3744,100C3648,100,3552,100,3456,100C3360,100,3264,100,3168,100C3072,100,2976,100,2880,100C2784,100,2688,100,2592,100C2496,100,2400,100,2304,100C2208,100,2112,100,2016,100C1920,100,1824,100,1728,100C1632,100,1536,100,1440,100C1344,100,1248,100,1152,100C1056,100,960,100,864,100C768,100,672,100,576,100C480,100,384,100,288,100C192,100,96,100,48,100L0,100Z"></path>
      <style>
          .nationalFlag{
              animation:pathFillAnimation 30s ease-in;
              animation-timing-function: linear;
              animation-iteration-count: infinite;
          }
          @keyframes  pathFillAnimation{
              0%{
                  fill: #fcd20f;
              }
              20%{
                  fill: #18b637;
              }
              40%{
                  fill: #000000;
              }
              60%{
                  fill: #18b637;
              }
              80%{
                  fill: #000000;
              }
              100%{
                  fill: #fcd20f;
              }
          }</style>
    </svg>
    <!-- BEGIN: POPULAR SERVICES -->
</div>
